export var BeeModes;

(function (BeeModes) {
  BeeModes["FULL"] = "full";
  BeeModes["LIGHT"] = "light";
  BeeModes["DEV"] = "dev";
})(BeeModes || (BeeModes = {}));